<template>
  <div :class="$style['chart-selection']">
    <mds-section>
      <template #mds-section-title>
        <mds-tabs
          :content="chartTabContent"
          v-on:mds-tabs-item-active="setActiveItem"
        >
        </mds-tabs>
      </template>
      <template #mds-section-actions>
        <slot name="right-side-section"></slot>
      </template>
    </mds-section>
    <div :style="contentWidth">
      <slot name="tabBody"></slot>
    </div>
  </div>
</template>
<script>
import { MdsTabs } from "@mds/tabs";
import MdsSection from "@mds/section";

export default {
  props: {
    chartTabContent: {
      type: Array,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      toggle: false,
    };
  },
  computed: {
    contentWidth() {
      if (this.height > 0) {
        return `min-height : ${this.height}px ;`;
      }
      return 0;
    },
  },
  components: {
    MdsTabs,
    MdsSection,
  },
  methods: {
    setActiveItem(event) {
      this.chartTabContent.forEach((item) => {
        if (item.id === event.currentTarget.id) {
          this.chartTabId = item.id;
          this.$emit("onSelectedTab", this.chartTabId);
          item.active = true;
        } else {
          item.active = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" module>
.chart-selection {
  .mds-section__actions{
    position:relative
  }
  .mds-tabs {
    border-bottom: none !important;
  }

  .mds-section--primary {
    border-top: none !important;
    border-bottom: solid 2px #f2f2f2;
  }
}
</style>
